<template>
  <a-row class="sec-main-cont">
    <a-col class="left-wrap" :span="5">
      <DataHeader class="wrap-heating-chart">
        <div class="dataHeaderTitle" slot="title">陆股通板块资金
          <ul class="block-checkout poa">
            <li class="fl"
              v-for="(item, index) in dateList" 
              :key="index" 
              :class="dateIndex===index?'date-active':''" 
              @click="checkoutDate(index)"
            >{{item}}</li>
          </ul>
        </div>
        <TreeMap slot="cont" :treeMapData="treeMapCurrentData" :cur="dateIndex" v-if="treeMapCurrentData.length" />
      </DataHeader>
      <DataHeader class="wrap-stock-list" :marginTop="3">
        <div class="dataHeaderTitle" slot="title">个股榜单</div>
        <StockList slot="cont"/>
      </DataHeader>
    </a-col>
    <a-col class="mid-wrap" :span="13">
      <BlockListDetail v-if="showBlock" :baseInfo="baseInfo" :days="dateList[dateIndex]"/>
      <StockListDetail :stockSelected="stockSelected" v-if="!showBlock" />
    </a-col>
    <a-col class="right-wrap" :span="6">
      <DataHeader class="wrap-stock-chart">
        <div class="dataHeaderTitle" slot="title">
          <div class="mid-wrap-title">资金流向</div>
        </div>
        <ComposeChart slot="cont" />
      </DataHeader>
    </a-col>
  </a-row>
</template>

<script>
import DataHeader from './dataHeader/dataHeader'
import StockList from './stockList/stockList'
import TreeMap from './treeMap/treeMap'
import BlockListDetail from './blockListDetail/blockListDetail'
import StockListDetail from './stockListDetail/stockListDetail'
import ComposeChart from './composeChart/composeChart'
import { getConceptList } from '../assets/js/action'
import { sortByKey } from '../assets/js/utils'
import event from './event'
export default {
  components: {
    DataHeader,
    StockList,
    TreeMap,
    StockListDetail,
    BlockListDetail,
    ComposeChart
  },
  data() {
    return {
      dateList: ['1日', '近5日', '近20日'],
      dateIndex: 0, // 热力图默认选中日期
      treeMapData: [], 
      treeMapCurrentData: [], // 热力图接口数据 
      stockSelected: 1,
      showBlock: false,
      baseInfo: {}
    }
  },
  mounted () {
    this.getSelect()
    this.getConceptListData()
  },
  methods: {
    checkoutDate(index) {
      /* 
      * 切换显示日周年概念热力图
      */
      let rltStat = ''
      this.dateIndex = index
      this.treeMapCurrentData = [] // 存储当前热力图数据
      if (index === 0) {
        this.treeMapCurrentData = this.getFirstAndLastTenData(this.treeMapData.sort(sortByKey('inflow')))
        this.treeMapCurrentData.map((item, index) => {
          this.treeMapCurrentData[index].curInflow = item.inflow
        })
        rltStat = '1day'
      } else if (index === 1) {
        this.treeMapCurrentData = this.getFirstAndLastTenData(this.treeMapData.sort(sortByKey('five_inflow')))
        this.treeMapCurrentData.map((item, index) => {
          this.treeMapCurrentData[index].curInflow = item.five_inflow
        })
        rltStat = '5day'
      } else if (index === 2) {
        this.treeMapCurrentData = this.getFirstAndLastTenData(this.treeMapData.sort(sortByKey('twenty_inflow')))
        this.treeMapCurrentData.map((item, index) => {
          this.treeMapCurrentData[index].curInflow = item.twenty_inflow
        })
        rltStat = '20day'
      }
      window.TA.log({
        id: `webhsgt_rlt_${rltStat}`
      })
    },
    getConceptListData() {
      /* 
      * 获取概念列表
      */
      getConceptList().then(data => {
        let _data = data.data.data
        this.treeMapData = data.data.data
        this.treeMapCurrentData = this.getFirstAndLastTenData(_data.sort(sortByKey('inflow')))
        this.treeMapCurrentData.map((item, index) => {
          this.treeMapCurrentData[index].curInflow = item.inflow
        })
      })
    },
    getFirstAndLastTenData(data) {
      /* 
      * 获取资金流入前十和后十数据
      */
      let _data = []
      if (data.length > 20) {
        for (let i = 0; i < 10; i++) {
          _data.push(data[i])
        }
        for (let i = data.length - 1; i >= data.length - 10; i--) {
          _data.push(data[i])
        }
      } else {
        _data = data
      }
      return _data
    },
    getSelect() {
      // 获取个股榜点击
      event.subscribe('stockListSelected', index => {
        this.showBlock = false
        this.stockSelected = index
      })
      // 监听treeMap点击事件
      event.subscribe('treeMapData', data => {
        this.showBlock = true
        this.baseInfo = data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.sec-main-cont {
  width: 1365px;
  height: 679px;
  color: #fff;
  margin: 3px 7px 6px 0px;
  .left-wrap, .mid-wrap , .right-wrap {
      height: 100%;
      .wrap-heating-chart {
        height: 476px;
      }
      .wrap-stock-list {
        height: 200px;
      }
  }
  .block-checkout {
    right: 0;
    top: 5px;
    height: 20px;
    line-height: 18px;
    font-size: 12px;
    color: #666666;
    background: #171b1d;
    font-family: SimSun;
    li {
      width: 45px;
      height: 20px;
      box-sizing: border-box;
      border: 1px solid #313131;
      text-align: center;
      font-size: 12px;
      &.date-active {
        color: #ffffff;
        background: #c63031;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
} 
.newblack{
  .sec-main-cont{
    width: 1369px;
    border: 1px solid #cbcbe1;
    color: #272841;
    .block-checkout{
      color: #272841;
      background: #e4e4f2;
      li{
        border: 1px solid #fff;
        &.date-active {
          color: #ffffff;
          background: #1b63d9;
        }
      }
    }
  }
}
.newgrey{
  .sec-main-cont{
    width: 1369px;
    border: 1px solid #2e2e33;
    color: #fff;
    .block-checkout{
      color: #fff;
      background: #181c21;
      li{
        border: 1px solid #181c21;
        background: #393941;
        &.date-active {
          color: #ffffff;
          background: #1b63d9;
        }
      }
    }
  }
}
</style>
